import  { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getFlexCaptureURL } from '../../constants';

export const walletInstallmentsApi = createApi({
  reducerPath: 'walletinstallmentsapi',
  baseQuery: fetchBaseQuery({ baseUrl: getFlexCaptureURL() }),
  endpoints: builder => ({
    getWalletInstallments: builder.mutation({
      query: ({ operation, provider, token }) => ({
        url: `/operation/${operation.id}/wallet/installments`,
        method: 'POST',
        body: {
          operation,
          provider,
          token
        }
      })
    })
  })
});

export const { useGetWalletInstallmentsMutation } = walletInstallmentsApi;
